import { render, staticRenderFns } from "./zijian_03.vue?vue&type=template&id=4ba05d64&scoped=true&"
import script from "./zijian_03.vue?vue&type=script&lang=js&"
export * from "./zijian_03.vue?vue&type=script&lang=js&"
import style0 from "./zijian_03.vue?vue&type=style&index=0&id=4ba05d64&prod&lang=less&"
import style1 from "./zijian_03.vue?vue&type=style&index=1&id=4ba05d64&prod&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba05d64",
  null
  
)

export default component.exports